export default "__VITE_ASSET__530ae14e__"